import styled from "@emotion/styled";

const PREVIEW_HEIGHT = "300px";
const FOOTER_HEIGHT = "50px";

export const StyledNotePreviewContainer = styled.div<{ width?: string }>`
  background-color: ${({ theme }) => theme.colors.grey.x0};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  box-shadow: ${({ theme }) => theme.shadows.popover};
  border: 1px solid ${({ theme }) => theme.colors.grey.x100};
  height: ${PREVIEW_HEIGHT};
  user-select: text;
  width: ${({ width }) => width || "400px"};
  max-width: calc(100vw - 60px);
`;

export const StyledContentArea = styled.div`
  height: calc(${PREVIEW_HEIGHT} - ${FOOTER_HEIGHT});
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledContentPadding = styled.div`
  height: ${({ theme }) => theme.spacing.sm};
`;

export const StyledFooter = styled.div`
  background-color: ${({ theme }) => theme.colors.grey.x50};
  height: ${FOOTER_HEIGHT};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.sm};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.medium}px;
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.medium}px;
  text-align: left;
`;

export const StyledFooterTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-size: ${({ theme }) => theme.fontSizes.xxxsmall};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.grey.x700};
  text-align: left;
`;

export const StyledFooterMetadata = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xxxsmall};
  line-height: ${({ theme }) => theme.lineHeights.xxsmall};
  color: ${({ theme }) => theme.colors.grey.x500};
  text-align: left;
`;
